<template>
  <div class="search-page">
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.parts_search.parts_search') }}
      </h1>
    </div>
    <main class="search-page__main">
      <div class="search">
        <div class="input-block input-block_search search__block">
          <div class="input-block_search__wrapper">
            <input
              ref="searcher"
              v-model.trim="searchStr"
              :placeholder="$t('views.parts_search.placeholder')"
              type="text"
              class="input-block__input input-block__input_white"
            >
            <img
              class="input-block_search__icon"
              src="@/assets/images/mini-search.svg"
            >
          </div>
        </div>
        <app-loader v-if="loading" />
        <v-row v-else>
          <v-col
            v-for="part in parts"
            :key="part.id"
            :cols="workMode.isModeSollers ? 6 : 4"
            class="search-page__col"
          >
            <part-card
              :part="part"
            />
          </v-col>
        </v-row>
      </div>
    </main>
  </div>
</template>

<script>
import _debounce from 'lodash.debounce';
import AppLoader from '@/components/common/AppLoader';
import PartCard from '@/components/orders/PartCard';
import { mapState } from 'vuex';

export default {
  name: 'PartsSearch',

  components: {
    AppLoader,
    PartCard,
  },

  data() {
    return {
      parts: [],
      loading: false,
    };
  },

  computed: {
    searchStr: {
      get() {
        return this.$route.query.search || '';
      },
      set(val) {
        this.$router.push({ query: { search: val || undefined } });
      },
    },
    ...mapState(['workMode']),
  },

  watch: {
    searchStr() {
      this.debounceGetParts();
    },
  },

  created() {
    this.debounceGetParts = _debounce(this.getParts, 500);
    if (this.searchStr) {
      this.debounceGetParts();
    }
  },

  mounted() {
    this.$refs.searcher.focus();
  },

  methods: {
    async getParts() {
      this.parts = [];
      if (!this.searchStr) {
        return;
      }

      this.loading = true;
      try {
        const { data } = await this.$http.get('/parts/search', {
          params: { query: this.searchStr, pageSize: 30 },
        });
        this.parts = data.rows;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.search-page {
  .search {
    &__block {
      width: 586px;
      margin-bottom: 55px;
    }
  }
}

@media (max-width: 1579px) {
  .search-page .search-page__col  {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}
</style>
